import { ActivityInfo } from '../constants';
import { useAppSelector } from '../hooks';

export function useCurrentActivityInfo(): ActivityInfo {
  const currentActivityInfo = useAppSelector(state => state.activity.currentActivityInfo);
  return currentActivityInfo;
}
